import { render, staticRenderFns } from "./RegisterMailAddressRequested.vue?vue&type=template&id=1b5ee314&lang=pug&"
import script from "./RegisterMailAddressRequested.vue?vue&type=script&lang=js&"
export * from "./RegisterMailAddressRequested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports